/**
 * URLs públicas do WSJ Pedidos (sem secrets).
 * Ordem: variável de ambiente (build) → fallback por ambiente.
 * - Desenvolvimento sem .env: localhost (app Vite típica na 5173).
 * - Produção sem .env: domínio público pedidos.wsjsolucoesdigitais.com
 */
import { getWsjCommercialWhatsappUrl } from './wsjCommercialWhatsapp';

const WSJ_PEDIDOS_DEMO_PATH = '/app/marimeloconfeitaria/menu';
const PROD_DEMO = `https://pedidos.wsjsolucoesdigitais.com${WSJ_PEDIDOS_DEMO_PATH}`;
const PROD_ADMIN = 'https://pedidos.wsjsolucoesdigitais.com/admin';
const LOCAL_DEMO = `http://localhost:5173${WSJ_PEDIDOS_DEMO_PATH}`;
const LOCAL_ADMIN = 'http://localhost:5173/admin';

const WSJ_PEDIDOS_WHATSAPP_FALLBACK = 'Olá! Quero saber mais sobre o WSJ Pedidos.';

/**
 * WhatsApp comercial (Portugal) — CTAs da página WSJ Pedidos (mensagem do i18n).
 */
export function getWsjPedidosCommercialWhatsappUrl(message) {
  return getWsjCommercialWhatsappUrl(message, WSJ_PEDIDOS_WHATSAPP_FALLBACK);
}

function resolveFallbacks() {
  if (process.env.NODE_ENV === 'development') {
    return { demo: LOCAL_DEMO, admin: LOCAL_ADMIN };
  }
  return { demo: PROD_DEMO, admin: PROD_ADMIN };
}

export function getWsjPedidosDemoUrl() {
  const fromEnv = String(process.env.VITE_WSJ_PEDIDOS_DEMO_URL || '').trim();
  if (fromEnv) return fromEnv;
  return resolveFallbacks().demo;
}

export function getWsjPedidosAdminUrl() {
  const fromEnv = String(process.env.VITE_WSJ_PEDIDOS_ADMIN_URL || '').trim();
  if (fromEnv) return fromEnv;
  return resolveFallbacks().admin;
}
